import axios from "axios";

const instance = axios.create({
  baseURL: "https://prav-product.ru/",
  // withCredentials: true,
  headers: { accept: "*/*" },
});

export default instance;
